"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Header = _interopRequireDefault(require("./Header"));

var _Footer = _interopRequireDefault(require("./Footer"));

var _Tabs = _interopRequireDefault(require("./Tabs"));

var _index = require("./style/index");

var _excluded = ["header", "footer", "children"];

var _this = void 0;

var headerShape = {
  /** 图标，传入string时为图标类型，也可直接传入图标组件 */
  icon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** icon类名前缀，当icon为图标组件时，会被忽略*/
  prefix: _propTypes["default"].string,

  /** 产品页头的内容 */
  content: _propTypes["default"].node,

  /** 右侧操作区域，通常为一些入口链接 */
  extra: _propTypes["default"].node
};
var footerShape = {
  /** 产品页脚的内容 */
  content: _propTypes["default"].node,

  /** 页脚的内容所占栅格数，用于与内容区对齐 */
  colSpan: _propTypes["default"].number
};
/**
 * ProductLayout
 * @description 布局组件
 */

var ProductLayout = function ProductLayout(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var header = _ref.header,
      footer = _ref.footer,
      children = _ref.children,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var renderHeader = function renderHeader() {
    (0, _newArrowCheck2["default"])(this, _this2);

    if (!(0, _isObject2["default"])(header)) {
      return null;
    }

    var icon = header.icon,
        prefix = header.prefix,
        content = header.content,
        extra = header.extra;
    return /*#__PURE__*/_react["default"].createElement(_Header["default"], {
      icon: icon,
      prefix: prefix,
      extra: extra
    }, content);
  }.bind(this);

  var renderFooter = function renderFooter() {
    (0, _newArrowCheck2["default"])(this, _this2);

    if (!(0, _isObject2["default"])(footer)) {
      return null;
    }

    var content = footer.content,
        colSpan = footer.colSpan;
    return /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
      colSpan: colSpan
    }, content);
  }.bind(this);

  return /*#__PURE__*/_react["default"].createElement(_index.StyledWrapper, others, renderHeader(), children, renderFooter());
}.bind(void 0);

ProductLayout.propTypes = {
  /** 产品页头，不传则不显示页头 */
  header: _propTypes["default"].shape(headerShape),

  /** 页脚的内容，不传则不显示页脚 */
  footer: _propTypes["default"].shape(footerShape),

  /** @ignore */
  className: _propTypes["default"].string,

  /** @ignore */
  style: _propTypes["default"].object,

  /** @ignore */
  children: _propTypes["default"].node
};
ProductLayout.defaultProps = {};
var _default = ProductLayout;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ProductLayout/ProductLayout.js
// module id = 2126
// module chunks = 6 7 17 18